import './form.css';
export default {
  "form": "pf-c-form",
  "formActions": "pf-c-form__actions",
  "formFieldGroup": "pf-c-form__field-group",
  "formFieldGroupBody": "pf-c-form__field-group-body",
  "formFieldGroupHeader": "pf-c-form__field-group-header",
  "formFieldGroupHeaderActions": "pf-c-form__field-group-header-actions",
  "formFieldGroupHeaderDescription": "pf-c-form__field-group-header-description",
  "formFieldGroupHeaderMain": "pf-c-form__field-group-header-main",
  "formFieldGroupHeaderTitle": "pf-c-form__field-group-header-title",
  "formFieldGroupHeaderTitleText": "pf-c-form__field-group-header-title-text",
  "formFieldGroupToggle": "pf-c-form__field-group-toggle",
  "formFieldGroupToggleButton": "pf-c-form__field-group-toggle-button",
  "formFieldGroupToggleIcon": "pf-c-form__field-group-toggle-icon",
  "formFieldset": "pf-c-form__fieldset",
  "formGroup": "pf-c-form__group",
  "formGroupControl": "pf-c-form__group-control",
  "formGroupLabel": "pf-c-form__group-label",
  "formGroupLabelHelp": "pf-c-form__group-label-help",
  "formGroupLabelInfo": "pf-c-form__group-label-info",
  "formGroupLabelMain": "pf-c-form__group-label-main",
  "formHelperText": "pf-c-form__helper-text",
  "formHelperTextIcon": "pf-c-form__helper-text-icon",
  "formLabel": "pf-c-form__label",
  "formLabelRequired": "pf-c-form__label-required",
  "formLabelText": "pf-c-form__label-text",
  "formSection": "pf-c-form__section",
  "formSectionTitle": "pf-c-form__section-title",
  "modifiers": {
    "horizontal": "pf-m-horizontal",
    "alignRight": "pf-m-align-right",
    "noPaddingTop": "pf-m-no-padding-top",
    "horizontalOnXs": "pf-m-horizontal-on-xs",
    "horizontalOnSm": "pf-m-horizontal-on-sm",
    "horizontalOnMd": "pf-m-horizontal-on-md",
    "horizontalOnLg": "pf-m-horizontal-on-lg",
    "horizontalOnXl": "pf-m-horizontal-on-xl",
    "horizontalOn_2xl": "pf-m-horizontal-on-2xl",
    "limitWidth": "pf-m-limit-width",
    "action": "pf-m-action",
    "info": "pf-m-info",
    "disabled": "pf-m-disabled",
    "inline": "pf-m-inline",
    "stack": "pf-m-stack",
    "error": "pf-m-error",
    "success": "pf-m-success",
    "warning": "pf-m-warning",
    "inactive": "pf-m-inactive",
    "hidden": "pf-m-hidden",
    "expanded": "pf-m-expanded"
  },
  "themeDark": "pf-theme-dark"
};